module.exports = __webpack_public_path__ + "static/media/tq.5f9637fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/tq.jpg
// module id = 1198
// module chunks = 110